<template>
    <section class="final-projects">
        <ul class="terms" v-if="terms">
            <li v-for="term in terms">
                <div class="toggle" @click.prevent="selectedTerm === term.id ? selectedTerm = null : selectedTerm=term.id">
                    <i v-if="selectedTerm===term.id" class="fa fa-caret-down"></i>
                    <i v-else class="fa fa-caret-right"></i>
                    {{term.name}}
                    <span style="color: #C33B3A;">{{ term.projects ? " " +term.projects + " project(s) need feedback" : "" }}</span>
                    <span v-if="term.projects && term.notClouded">|</span>
                    <span style="color: #3AC384;">{{ term.notClouded ? " " +term.notClouded +" passed project(s) not in cloudinary" : "" }}</span>
                </div>
                <div v-if="selectedTerm==term.id">
                    <div v-for="(students, path) in term.students">
                        <h3>{{pathName(path)}}</h3>
                        <ul class="students">
                            <li v-for="student in students">
                                <router-link :to="{ name: 'student', params: { studentId: student.populiId }, query: {userId: student.id, open: 'projects', term: term.id}}">                                                                        
                                    <h3>{{student.firstName}} {{student.lastName}}</h3>

                                    <div class="status" :class="student.projectStatus">
                                        {{student.projectStatus | deslugify}}
                                    </div>
                                </router-link>
                                
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </section>
</template>
<script>
import finalProjects from '../../services/final-projects';
import paths from '../../services/paths';

import _ from 'lodash';

export default {
    data() {
        return {
            terms: null,
            paths: null,
            selectedTerm: "212365"
        }
    },
    components: {

    },
    async mounted() {
        await this.getPaths();
        this.getProjects();
    },
    methods: {
        pathName(path) {
            let pathName = this.paths.find((p) => { return p.id === parseInt(path) });
            if (pathName) return pathName.name;
            return 'No Path Set';
        },
        getPaths() {
            return paths.getPaths(this).then((response) => {
                this.paths = response;
                return true;
            });
        },
        getStatus(studentProjects) {
            if (!studentProjects || studentProjects.length === 0) 
                return 'no_hand_in';

            let projects = _.clone(studentProjects);
            projects = projects.sort((a, b) => { return new Date(b.createdAt) - new Date(a.createdAt) });
                     
            if(!projects[0].final_feedbacks || projects[0].final_feedbacks.length === 0)
                if (projects[0].ignores == 0 || projects[0].ignores == 2)
                    return 'requiring_feedback';
                else
                    return 'Feedback - Snoozed';

            if (projects[0].passed){
                // console.log(projects[0].cloudinaryIds)
                if (!projects[0].cloudinaryIds || projects[0].cloudinaryIds.length == 0){
                    if (projects[0].ignores == 0 || projects[0].ignores == 1) 
                        return 'passed - Not in Cloudinary'
                    else
                        return 'Passed - Snoozed'
                }
                else
                    return 'passed'
            }

            return 'fixes_required';
        },
        getProjects() {
            var self = this;
            const now = new Date();

            finalProjects.get().then(function(response) {
                self.terms = response.data.terms.filter((t) => {
                    t.projects = 0
                    t.notClouded = 0
                    return new Date(t.startDate) <= now;
                }).map((t) => {
                    t.students = _.groupBy(t.students, function(s) { return s.path });
                    Object.values(t.students).forEach(students => {
                        students.forEach(student => {
                            student.projectStatus = self.getStatus(student.final_projects)
                            // console.log(status)
                            t.projects += student.projectStatus == "requiring_feedback" ? 1 : 0
                            t.notClouded += student.projectStatus == "passed - Not in Cloudinary" ? 1 : 0
                        })
                    })
                    return t;
                });
            });
            
        },
        latestThumbnail(projects) {
            if (!projects || projects.length === 0) {
                return './../../static/static/img/reel-placeholder.jpg';
            }
            let latest = projects.filter(function(t) { return t.thumbnail }).sort(function(a, b) { return new Date(b.createdAt) - new Date(a.createdAt) })[0];

            if (latest) {
                if (latest.thumbnail.includes('amazonaws')) {
                    return latest.thumbnail;
                }
                return 'https://drive.google.com/uc?export=view&id=' + latest.thumbnail;
            }
            return './../../static/static/img/reel-placeholder.jpg';
        }
    },
    computed: {

    }
}

</script>
<style lang="scss" scoped>
.toggle {
    cursor: pointer;
}

section {
    padding: 1rem;
}

.students {
    display: flex;
    flex-wrap: wrap;

    h3 {
        font-size: 1.8rem;
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    li {
        padding: 1rem;
        text-align:center;
        &:hover {
            background:#333;
        }
    }

    img {
        width: 150px;
        height: 150px;
        object-fit: cover;
    }
    a:hover {
        text-decoration:none;
    }
}

.status {
    border: 1px solid #bebebe;
    text-align: center;
    padding: .5rem;
    color: #1a1a1a;
    width:200px;


    &.passed,&.Passed.Snoozed {
        background: #3AC384;
    }

    &.requiring_feedback {
        background: #C33B3A;
    }

    &.Feedback {
        background: #986565;
    }

    &.fixes_required {
        background: #3AB8C4;
    }

    &.no_hand_in {
        background: #999999;
    }
}



</style>



// WEBPACK FOOTER //
// FinalProjects.vue?188215cb